import { useNavigate } from "react-router-dom";
import HomeRecentWork from "./components/homeRecentWork";
import { AppStorage } from "../../features/storage/appStorage";
import AskSovraPrompt from "./components/askSovraPrompt";
import HomeCommercialRequirements from "./components/homeCommercialRequirements";
import HomeFreshness from "./components/homeFreshness";
import HomeSovraHasFound from "./components/sovraHasFound";

const getGreetingName = (email: string | null): string => {
    const localPart = email?.split("@")[0] ?? "";
    const firstSegment = localPart.split(/[._+-]/)[0] ?? "";
    const letters = firstSegment.replace(/[^a-zA-Z]/g, "");

    if (!letters) {
        return "there";
    }

    return `${letters.charAt(0).toUpperCase()}${letters.slice(1).toLowerCase()}`;
};

const getTimeGreeting = (date: Date): string => {
    const hour = date.getHours();

    if (hour < 12) {
        return "Good morning";
    }

    if (hour < 17) {
        return "Good afternoon";
    }

    return "Good evening";
};

const SectionSpacer = () => (<hr className="my-4 my-lg-5" style={{ opacity: 0.05 }} />);

const Home: React.FC = () => {
    const navigate = useNavigate();
    const greetingName = getGreetingName(AppStorage.getUserEmail());
    const greeting = getTimeGreeting(new Date());

    const handleConversationSelected = (conversationId: number): void => {
        const searchParams = new URLSearchParams({
            id: conversationId.toString()
        });

        void navigate(`/app/workspace/simulator?${searchParams.toString()}`);
    };

    return (
        <main className="flex-grow-1 min-h-0 overflow-hidden d-flex flex-column">
            <div className="flex-grow-1 min-h-0 overflow-auto">
                <div className="mx-auto w-100 px-3 py-4 py-lg-5" style={{ maxWidth: "66rem" }}>
                    <header className="text-center mb-4">
                        <h1 className="fw-medium mb-2 fs-4" style={{ lineHeight: "36px" }}>
                            {greeting}
                            ,
                            {" "}
                            {greetingName}
                        </h1>
                        <p className="text-secondary mb-3">What should your business do next?</p>
                        <HomeFreshness />
                    </header>

                    <HomeCommercialRequirements />

                    <SectionSpacer />

                    <HomeSovraHasFound />

                    <SectionSpacer />

                    <HomeRecentWork onChange={handleConversationSelected} />
                </div>
            </div>
            <AskSovraPrompt />
        </main>
    );
};

export default Home;
